import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { io } from 'socket.io-client';
import { SupportClient, resolveApiBase } from './api';
import { EMOJIS } from './emojis';
import { formatFullTime, formatTime, maxServerId, mergeMessages, queueText, toUiMessage } from './messages';
let clientSeq = 0;
function nextClientId() {
    clientSeq += 1;
    return `c${Date.now().toString(36)}${clientSeq.toString(36)}${Math.random().toString(36).slice(2, 6)}`;
}
function joinUrl(base, path) {
    if (!path)
        return undefined;
    if (/^https?:\/\//i.test(path))
        return path;
    return `${base.replace(/\/+$/, '')}${path.startsWith('/') ? path : `/${path}`}`;
}
const CSS = `
.dtsw-root{position:fixed;bottom:20px;z-index:2147000000;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Microsoft YaHei",sans-serif;font-size:14px;line-height:1.5;color:#1f2329}
.dtsw-root.dtsw-right{right:20px}
.dtsw-root.dtsw-left{left:20px}
.dtsw-launcher{width:54px;height:54px;border-radius:50%;border:none;cursor:pointer;background:linear-gradient(135deg,#1677ff,#4096ff);color:#fff;font-size:22px;box-shadow:0 6px 20px rgba(22,119,255,.4);position:relative;transition:transform .15s ease}
.dtsw-launcher:hover{transform:scale(1.06)}
.dtsw-badge{position:absolute;top:-4px;right:-4px;min-width:18px;height:18px;padding:0 4px;border-radius:9px;background:#f5222d;color:#fff;font-size:11px;line-height:18px;text-align:center}
.dtsw-panel{position:absolute;bottom:66px;width:380px;height:560px;max-height:calc(100vh - 100px);background:#fff;border:1px solid #e5e7eb;border-radius:14px;box-shadow:0 12px 40px rgba(15,23,42,.18);display:flex;flex-direction:column;overflow:hidden;animation:dtsw-in .18s ease}
.dtsw-right .dtsw-panel{right:0}
.dtsw-left .dtsw-panel{left:0}
@keyframes dtsw-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
.dtsw-head{display:flex;align-items:center;justify-content:space-between;padding:10px 12px;background:linear-gradient(135deg,#1677ff,#4096ff);color:#fff}
.dtsw-head-left{display:flex;align-items:center;gap:10px;min-width:0}
.dtsw-logo{width:32px;height:32px;border-radius:8px;background:rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center;font-weight:700}
.dtsw-title{font-weight:600;font-size:14px}
.dtsw-status{font-size:12px;opacity:.9;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:220px}
.dtsw-head-actions{display:flex;gap:4px}
.dtsw-head-actions button{background:transparent;border:none;color:#fff;font-size:14px;cursor:pointer;width:26px;height:26px;border-radius:6px}
.dtsw-head-actions button:hover{background:rgba(255,255,255,.18)}
.dtsw-msgs{flex:1;overflow-y:auto;padding:12px;background:#f5f7fb;display:flex;flex-direction:column;gap:8px}
.dtsw-hint{text-align:center;font-size:12px;color:#8c8c8c;padding:4px 0}
.dtsw-offline{color:#d46b08}
.dtsw-error{margin:0 auto;background:#fff2f0;border:1px solid #ffccc7;color:#cf1322;border-radius:8px;padding:6px 10px;font-size:12px;display:flex;align-items:center;gap:8px}
.dtsw-error button{border:none;background:#cf1322;color:#fff;border-radius:6px;padding:2px 8px;cursor:pointer;font-size:12px}
.dtsw-row{display:flex}
.dtsw-row.dtsw-right{justify-content:flex-end}
.dtsw-bubble{max-width:78%;background:#fff;border:1px solid #ececf0;border-radius:10px;padding:8px 10px;box-shadow:0 1px 2px rgba(15,23,42,.04)}
.dtsw-row.dtsw-right .dtsw-bubble{background:#1677ff;border-color:#1677ff;color:#fff}
.dtsw-failed{outline:1.5px solid #ff4d4f}
.dtsw-label{font-size:11px;color:#8c8c8c;margin-bottom:2px}
.dtsw-row.dtsw-right .dtsw-label{color:rgba(255,255,255,.85)}
.dtsw-text{white-space:pre-wrap;word-break:break-word}
.dtsw-img{max-width:200px;max-height:200px;border-radius:8px;display:block}
.dtsw-video{max-width:220px;border-radius:8px;display:block}
.dtsw-file{color:inherit;text-decoration:underline;word-break:break-all}
.dtsw-card{min-width:200px}
.dtsw-card-title{font-weight:600;margin-bottom:2px}
.dtsw-card-desc{font-size:12px;color:#5c6370;margin-bottom:6px}
.dtsw-row.dtsw-right .dtsw-card-desc{color:rgba(255,255,255,.85)}
.dtsw-card-foot{display:flex;align-items:center;justify-content:space-between;gap:8px}
.dtsw-card-foot a{color:inherit;font-size:12px;text-decoration:underline}
.dtsw-refs{margin-top:6px;display:flex;flex-direction:column;gap:2px}
.dtsw-refs a{font-size:12px;color:#1677ff;text-decoration:underline;word-break:break-all}
.dtsw-meta{font-size:11px;color:#bfbfc6;margin-top:4px;display:flex;align-items:center;gap:6px}
.dtsw-row.dtsw-right .dtsw-meta{color:rgba(255,255,255,.75)}
.dtsw-meta button{border:1px solid currentColor;background:transparent;color:inherit;border-radius:6px;font-size:11px;padding:0 6px;cursor:pointer}
.dtsw-sys{text-align:center;font-size:12px;color:#8c8c8c;background:#eef1f6;border-radius:8px;padding:4px 10px;align-self:center;max-width:90%}
.dtsw-queue{background:#fff7e6;color:#ad6800;font-size:12px;padding:6px 12px;border-top:1px solid #ffe7ba}
.dtsw-cards{display:flex;gap:8px;overflow-x:auto;padding:8px 12px;background:#fff;border-top:1px solid #eef0f4}
.dtsw-chip{border:1px solid #dbeafe;background:#f0f7ff;color:#1677ff;border-radius:16px;padding:5px 10px;font-size:12px;white-space:nowrap;cursor:pointer}
.dtsw-chip:hover{background:#e6f4ff}
.dtsw-input{background:#fff;border-top:1px solid #eef0f4;padding:8px 10px}
.dtsw-emoji{display:flex;flex-wrap:wrap;gap:2px;max-height:110px;overflow-y:auto;padding-bottom:6px;border-bottom:1px solid #f0f0f0;margin-bottom:6px}
.dtsw-emoji button{border:none;background:transparent;font-size:18px;cursor:pointer;padding:2px 4px;border-radius:6px}
.dtsw-emoji button:hover{background:#f0f7ff}
.dtsw-input-row{display:flex;align-items:flex-end;gap:6px}
.dtsw-icon{border:none;background:transparent;font-size:18px;cursor:pointer;padding:2px;line-height:1}
.dtsw-icon:disabled{opacity:.5;cursor:default}
.dtsw-input-row textarea{flex:1;border:none;outline:none;resize:none;font-size:14px;line-height:1.45;max-height:80px;font-family:inherit;padding:4px 2px}
.dtsw-send{border:none;background:#1677ff;color:#fff;border-radius:8px;padding:6px 14px;font-size:13px;cursor:pointer}
.dtsw-send:disabled{background:#bfbfbf;cursor:default}
.dtsw-rate{padding:10px 12px;border-top:1px solid #eef0f4;background:#fff}
.dtsw-rate-title{font-size:12px;color:#666;margin-bottom:6px}
.dtsw-stars{display:flex;gap:6px;margin-bottom:8px}
.dtsw-star{border:none;background:transparent;font-size:22px;color:#d9d9d9;cursor:pointer;padding:0;line-height:1}
.dtsw-star-on{color:#faad14}
.dtsw-rate-actions{display:flex;align-items:center;gap:10px}
.dtsw-rate-skip{border:none;background:transparent;color:#999;font-size:12px;cursor:pointer}
.dtsw-rate-done{font-size:13px;color:#52c41a;text-align:center;padding:6px 0}
.dtsw-actions{display:flex;align-items:center;justify-content:space-between;margin-top:4px}
.dtsw-human{border:none;background:transparent;color:#1677ff;font-size:12px;cursor:pointer;padding:2px 0}
.dtsw-human:hover{text-decoration:underline}
.dtsw-tip{font-size:11px;color:#bfbfc6}
@media (max-width:640px){
.dtsw-panel{position:fixed;inset:0;width:100vw;height:100vh;height:100dvh;max-height:none;border-radius:0;border:none}
.dtsw-right .dtsw-panel,.dtsw-left .dtsw-panel{right:0;left:0}
}
`;
export function SupportWidget(props) {
    const { apiBase, title = 'DTwince 在线客服', defaultOpen = false, position = 'right', zIndex = 2147000000, marketingSiteBase = '', } = props;
    const clientRef = useRef(null);
    if (!clientRef.current)
        clientRef.current = new SupportClient(props);
    const client = clientRef.current;
    const [mounted, setMounted] = useState(false);
    const [open, setOpen] = useState(defaultOpen);
    const [boot, setBoot] = useState(null);
    const [hasSession, setHasSession] = useState(false);
    const [messages, setMessages] = useState([]);
    const [queue, setQueue] = useState(null);
    const [human, setHuman] = useState(false);
    const [agentName, setAgentName] = useState(null);
    const [unread, setUnread] = useState(0);
    const [error, setError] = useState(null);
    const [connecting, setConnecting] = useState(false);
    const [socketConnected, setSocketConnected] = useState(false);
    const [input, setInput] = useState('');
    const [emojiOpen, setEmojiOpen] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [typing, setTyping] = useState(false);
    const [closed, setClosed] = useState(false);
    const [ratingScore, setRatingScore] = useState(0);
    const [ratingBusy, setRatingBusy] = useState(false);
    const [ratingDone, setRatingDone] = useState(false);
    const socketRef = useRef(null);
    const sessionRef = useRef(null);
    const lastMessageIdRef = useRef(undefined);
    const openRef = useRef(open);
    const initPromiseRef = useRef(null);
    // 2026-10-17：连接失败退避（防 429 风暴导致"永久正在连接"）
    const retryTimerRef = useRef(null);
    const retryAttemptRef = useRef(0);
    const lastInitAtRef = useRef(0);
    const initSelfRef = useRef(null);
    const typingAtRef = useRef(0);
    const scrollRef = useRef(null);
    const fileRef = useRef(null);
    const readAtRef = useRef(0);
    openRef.current = open;
    useEffect(() => {
        setMounted(true);
        return () => {
            socketRef.current?.disconnect();
            socketRef.current = null;
            if (retryTimerRef.current != null)
                window.clearTimeout(retryTimerRef.current);
            retryTimerRef.current = null;
        };
    }, []);
    // 打开面板时清未读并懒加载会话
    // 2026-10-17 修复：deps 去掉 connecting（失败回 false 会立刻重跑→429 风暴）；加最小间隔冷却 + in-flight 去重，
    // 失败后的自动重试由 init() 内的指数退避负责（最多 3 次），再失败由「重试」按钮手动触发
    useEffect(() => {
        if (!mounted || !open || hasSession)
            return;
        if (initPromiseRef.current)
            return;
        if (Date.now() - lastInitAtRef.current < 2500)
            return;
        setUnread(0);
        void init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mounted, open, hasSession]);
    useEffect(() => {
        if (open)
            setUnread(0);
    }, [open]);
    // 已读回执：面板打开且收到新消息时上报（800ms 节流，避免重复请求）
    const markRead = useCallback(() => {
        const session = sessionRef.current;
        if (!session)
            return;
        const now = Date.now();
        if (now - readAtRef.current < 800)
            return;
        readAtRef.current = now;
        void client.markRead(session.token, session.conversationId).catch(() => undefined);
    }, [client]);
    useEffect(() => {
        if (!open || !hasSession)
            return;
        markRead();
    }, [open, hasSession, messages.length, markRead]);
    // 新消息自动滚底
    useEffect(() => {
        if (!open)
            return;
        const el = scrollRef.current;
        if (el)
            el.scrollTop = el.scrollHeight;
    }, [messages, typing, open, queue]);
    // 视口变化（移动端旋转/桌面缩放）后重新贴底
    useEffect(() => {
        if (!open)
            return;
        const onResize = () => {
            const el = scrollRef.current;
            if (el)
                el.scrollTop = el.scrollHeight;
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [open]);
    const append = useCallback((incoming) => {
        if (incoming.length === 0)
            return;
        setMessages((prev) => mergeMessages(prev, incoming));
        const mx = maxServerId(incoming);
        if (mx > Number(lastMessageIdRef.current ?? 0))
            lastMessageIdRef.current = String(mx);
        if (!openRef.current) {
            const fromOthers = incoming.filter((m) => m.senderType !== 'visitor');
            if (fromOthers.length > 0)
                setUnread((n) => n + fromOthers.length);
        }
    }, []);
    const applyConversation = useCallback((status) => {
        if (status === 'active') {
            setHuman(true);
            setQueue(null);
        }
        else if (status === 'queued') {
            setQueue((prev) => prev ?? { position: null, size: 0 });
        }
        else if (status === 'closed') {
            // S15：会话结束 → 展示满意度评价
            setClosed(true);
            setQueue(null);
        }
    }, []);
    const connectSocket = useCallback((token, conversationId) => {
        socketRef.current?.disconnect();
        const socket = io(`${resolveApiBase(apiBase)}/support`, {
            auth: { token },
            // CDN（www.dtwince.com）不支持 WebSocket upgrade 时会 400；先 polling 再尝试升级，避免“网络中断”
            transports: ['polling', 'websocket'],
            tryAllTransports: true,
            reconnection: true,
            reconnectionDelayMax: 8000,
        });
        socketRef.current = socket;
        socket.on('connect', () => {
            setSocketConnected(true);
            socket.emit('visitor:join', { conversationId, lastMessageId: lastMessageIdRef.current }, (ack) => {
                if (!ack?.ok) {
                    setError(ack?.error ?? '会话连接失败');
                    return;
                }
                if (ack.messages)
                    append(ack.messages.map(toUiMessage));
                if (ack.conversation)
                    applyConversation(ack.conversation.status);
                if (ack.queue && ack.queue.position != null) {
                    setQueue({ position: ack.queue.position, size: ack.queue.size ?? 0 });
                }
            });
        });
        socket.on('disconnect', () => setSocketConnected(false));
        socket.on('server:message', (payload) => {
            if (payload?.message)
                append([toUiMessage(payload.message)]);
        });
        socket.on('server:read', (payload) => {
            if (payload?.reader !== 'agent' || !payload.at)
                return;
            setMessages((prev) => prev.map((m) => m.senderType === 'visitor'
                ? { ...m, meta: { ...(m.meta ?? {}), readByAgentAt: payload.at } }
                : m));
        });
        socket.on('server:queue', (payload) => {
            setQueue({ position: payload?.position ?? null, size: payload?.size ?? 0 });
        });
        socket.on('server:agent-joined', (payload) => {
            setHuman(true);
            setQueue(null);
            if (payload?.agentName)
                setAgentName(payload.agentName);
        });
        socket.on('server:conversation', (payload) => {
            applyConversation(payload?.conversation?.status);
        });
        socket.on('server:typing', (payload) => {
            if (payload?.from && payload.from !== 'visitor') {
                setTyping(true);
                window.setTimeout(() => setTyping(false), 3000);
            }
        });
        socket.on('server:error', (payload) => {
            setError(payload?.message ?? '连接异常');
        });
    }, [apiBase, append, applyConversation]);
    const init = useCallback(() => {
        if (initPromiseRef.current)
            return initPromiseRef.current;
        const task = (async () => {
            lastInitAtRef.current = Date.now();
            setConnecting(true);
            setError(null);
            try {
                if (!boot) {
                    const info = await client.bootstrap();
                    setBoot(info);
                }
                let token = props.supportToken;
                if (!token && props.getSupportToken)
                    token = await props.getSupportToken();
                let session;
                try {
                    session = await client.openSession(token);
                }
                catch (e) {
                    // 2026-10-17：身份令牌（supportToken）验签失败（401，如两侧 SUPPORT_TOKEN_SECRET 不一致/过期）→
                    // 静默降级匿名访客通道，保证客服可用（服务端日志可查）
                    if (token && e.status === 401) {
                        console.warn('[support] supportToken 校验失败，降级匿名访客通道');
                        session = await client.openSession(undefined);
                    }
                    else {
                        throw e;
                    }
                }
                sessionRef.current = { token: session.visitorToken, conversationId: session.conversationId };
                setHasSession(true);
                retryAttemptRef.current = 0;
                if (retryTimerRef.current != null) {
                    window.clearTimeout(retryTimerRef.current);
                    retryTimerRef.current = null;
                }
                try {
                    setRatingDone(localStorage.getItem(`dtwince.support.rated.${session.conversationId}`) === '1');
                }
                catch {
                    // ignore
                }
                const initial = session.messages.map(toUiMessage);
                lastMessageIdRef.current = maxServerId(initial) > 0 ? String(maxServerId(initial)) : undefined;
                setMessages((prev) => mergeMessages(prev, initial));
                applyConversation(session.conversation.status);
                connectSocket(session.visitorToken, session.conversationId);
            }
            catch (e) {
                const message = e.message || '客服服务暂时不可用，请稍后重试';
                setError(message);
                // 2026-10-17：指数退避自动重试（2s/4s/8s），最多 3 次；之后停止（可由「重试」按钮手动再试）
                const attempt = retryAttemptRef.current + 1;
                retryAttemptRef.current = attempt;
                if (attempt <= 3) {
                    retryTimerRef.current = window.setTimeout(() => {
                        retryTimerRef.current = null;
                        void initSelfRef.current?.();
                    }, Math.min(30000, 2000 * 2 ** (attempt - 1)));
                }
            }
            finally {
                setConnecting(false);
                initPromiseRef.current = null;
            }
        })();
        initPromiseRef.current = task;
        return task;
    }, [applyConversation, boot, client, connectSocket, props.getSupportToken, props.supportToken]);
    // 供退避重试回调引用最新 init（避免闭包过期）
    initSelfRef.current = init;
    const emitMessage = useCallback((payload) => new Promise((resolve) => {
        const socket = socketRef.current;
        if (!socket?.connected) {
            resolve({ ok: false, error: '连接未就绪，请稍后重试' });
            return;
        }
        let settled = false;
        const timer = window.setTimeout(() => {
            if (!settled) {
                settled = true;
                resolve({ ok: false, error: '发送超时' });
            }
        }, 8000);
        socket.emit('visitor:message', payload, (ack) => {
            if (!settled) {
                settled = true;
                window.clearTimeout(timer);
                resolve(ack ?? { ok: false, error: '发送失败' });
            }
        });
    }), []);
    const sendPayload = useCallback(async (payload, reuseClientMsgId) => {
        if (!sessionRef.current)
            return;
        const clientMsgId = reuseClientMsgId ?? nextClientId();
        if (!reuseClientMsgId) {
            const optimistic = {
                id: `tmp-${clientMsgId}`,
                clientMsgId,
                senderType: 'visitor',
                msgType: payload.msgType,
                content: payload.content,
                assetUrl: payload.assetUrl ?? null,
                meta: payload.meta ?? null,
                createdAt: new Date().toISOString(),
                pending: true,
            };
            setMessages((prev) => mergeMessages(prev, [optimistic]));
        }
        else {
            setMessages((prev) => prev.map((m) => (m.clientMsgId === clientMsgId ? { ...m, pending: true, failed: false } : m)));
        }
        const ack = await emitMessage({ ...payload, clientMsgId });
        if (ack.ok && ack.message) {
            append([toUiMessage(ack.message)]);
        }
        else {
            setMessages((prev) => prev.map((m) => (m.clientMsgId === clientMsgId ? { ...m, pending: false, failed: true } : m)));
        }
    }, [append, emitMessage]);
    const sendText = useCallback(() => {
        const text = input.trim();
        if (!text)
            return;
        setInput('');
        setEmojiOpen(false);
        void sendPayload({ msgType: 'text', content: text });
    }, [input, sendPayload]);
    const requestHuman = useCallback(() => {
        const socket = socketRef.current;
        if (!socket?.connected)
            return;
        socket.emit('visitor:request-human', {}, (ack) => {
            if (!ack?.ok) {
                setError(ack?.error ?? '转人工失败');
                return;
            }
            if (ack.assigned) {
                setHuman(true);
                setQueue(null);
                if (ack.agentName)
                    setAgentName(ack.agentName);
            }
            else {
                setQueue({ position: ack.position ?? null, size: ack.size ?? 0 });
            }
        });
    }, []);
    const onPickFile = useCallback(async (file) => {
        const session = sessionRef.current;
        if (!session)
            return;
        const maxMB = boot?.upload.maxMB ?? 20;
        if (file.size > maxMB * 1024 * 1024) {
            setError(`文件大小不能超过 ${maxMB}MB`);
            return;
        }
        setUploading(true);
        setError(null);
        try {
            const up = await client.upload(session.token, file);
            await sendPayload({ msgType: up.msgType, content: up.name, assetUrl: up.url });
        }
        catch (e) {
            setError(e.message || '上传失败');
        }
        finally {
            setUploading(false);
        }
    }, [boot, client, sendPayload]);
    const onInputChange = useCallback((value) => {
        setInput(value);
        const now = Date.now();
        if (now - typingAtRef.current > 2500 && socketRef.current?.connected) {
            typingAtRef.current = now;
            socketRef.current.emit('visitor:typing', {});
        }
    }, []);
    // S15：提交满意度评价（1-5 星，本地记忆防重复）
    const submitRating = useCallback(async () => {
        const session = sessionRef.current;
        if (!session || !ratingScore)
            return;
        setRatingBusy(true);
        try {
            await client.rateConversation(session.token, session.conversationId, ratingScore);
            try {
                localStorage.setItem(`dtwince.support.rated.${session.conversationId}`, '1');
            }
            catch {
                // ignore
            }
            setRatingDone(true);
        }
        catch (e) {
            setError(e.message || '评价提交失败');
        }
        finally {
            setRatingBusy(false);
        }
    }, [client, ratingScore]);
    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendText();
        }
    }, [sendText]);
    const faq = useMemo(() => boot?.faq ?? [], [boot]);
    const cards = useMemo(() => boot?.cards ?? [], [boot]);
    if (!mounted)
        return null;
    const rootClass = `dtsw-root ${position === 'left' ? 'dtsw-left' : 'dtsw-right'}`;
    const rootStyle = { zIndex };
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: CSS }), _jsxs("div", { className: rootClass, style: rootStyle, children: [open && (_jsxs("section", { className: "dtsw-panel", "aria-label": title, children: [_jsxs("header", { className: "dtsw-head", children: [_jsxs("div", { className: "dtsw-head-left", children: [_jsx("span", { className: "dtsw-logo", children: "D" }), _jsxs("div", { children: [_jsx("div", { className: "dtsw-title", children: title }), _jsxs("div", { className: "dtsw-status", children: [connecting ? '正在连接…' : queueText(queue, human), human && agentName ? ` · ${agentName}` : ''] })] })] }), _jsxs("div", { className: "dtsw-head-actions", children: [_jsx("button", { onClick: () => setOpen(false), "aria-label": "\u6700\u5C0F\u5316", title: "\u6700\u5C0F\u5316", children: "\u2014" }), _jsx("button", { onClick: () => setOpen(false), "aria-label": "\u5173\u95ED", title: "\u5173\u95ED", children: "\u2715" })] })] }), _jsxs("div", { className: "dtsw-msgs", ref: scrollRef, children: [error && (_jsxs("div", { className: "dtsw-error", children: [_jsx("span", { children: error }), _jsx("button", { onClick: () => {
                                                    setError(null);
                                                    if (!hasSession)
                                                        void init();
                                                }, children: "\u91CD\u8BD5" })] })), connecting && _jsx("div", { className: "dtsw-hint", children: "\u6B63\u5728\u8FDE\u63A5\u5BA2\u670D\u2026" }), messages.map((m) => (_jsx(MessageBubble, { message: m, siteBase: marketingSiteBase, showReadStat: true, onRetry: (msg) => void sendPayload({
                                            msgType: msg.msgType,
                                            content: msg.content ?? '',
                                            assetUrl: msg.assetUrl ?? undefined,
                                            meta: msg.meta ?? undefined,
                                        }, msg.clientMsgId ?? undefined) }, m.clientMsgId ?? m.id))), typing && _jsx("div", { className: "dtsw-hint", children: "\u5BF9\u65B9\u6B63\u5728\u8F93\u5165\u2026" }), hasSession && !socketConnected && !connecting && (_jsx("div", { className: "dtsw-hint dtsw-offline", children: "\u7F51\u7EDC\u4E2D\u65AD\uFF0C\u6B63\u5728\u91CD\u8FDE\u2026" }))] }), queue && queue.position != null && !human && (_jsxs("div", { className: "dtsw-queue", children: ["\u23F3 ", queueText(queue, false)] })), (cards.length > 0 || faq.length > 0) && !closed && (_jsxs("div", { className: "dtsw-cards", children: [cards.map((card) => (_jsx("button", { className: "dtsw-chip", onClick: () => void sendPayload({
                                            msgType: 'card',
                                            content: card.title,
                                            meta: { card: { ...card, path: joinUrl(marketingSiteBase, card.path) } },
                                        }), children: card.title }, card.id))), faq.slice(0, 3).map((q) => (_jsx("button", { className: "dtsw-chip", onClick: () => void sendPayload({ msgType: 'text', content: q }), children: q }, q)))] })), closed && hasSession ? (_jsx("div", { className: "dtsw-rate", "data-testid": "rate-panel", children: ratingDone ? (_jsx("div", { className: "dtsw-rate-done", children: "\u2605 \u611F\u8C22\u60A8\u7684\u8BC4\u4EF7\uFF01" })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "dtsw-rate-title", children: "\u672C\u6B21\u4F1A\u8BDD\u5DF2\u7ED3\u675F\uFF0C\u60A8\u5BF9\u670D\u52A1\u6EE1\u610F\u5417\uFF1F" }), _jsx("div", { className: "dtsw-stars", children: [1, 2, 3, 4, 5].map((n) => (_jsx("button", { className: n <= ratingScore ? 'dtsw-star dtsw-star-on' : 'dtsw-star', onClick: () => setRatingScore(n), "aria-label": `${n} 星`, "data-testid": `rate-star-${n}`, children: "\u2605" }, n))) }), _jsxs("div", { className: "dtsw-rate-actions", children: [_jsx("button", { className: "dtsw-send", disabled: !ratingScore || ratingBusy, onClick: () => void submitRating(), "data-testid": "rate-submit", children: ratingBusy ? '提交中…' : '提交评价' }), _jsx("button", { className: "dtsw-rate-skip", onClick: () => setRatingDone(true), children: "\u6682\u4E0D\u8BC4\u4EF7" })] })] })) })) : (_jsxs("footer", { className: "dtsw-input", children: [emojiOpen && (_jsx("div", { className: "dtsw-emoji", children: EMOJIS.map((e) => (_jsx("button", { onClick: () => onInputChange(input + e), children: e }, e))) })), _jsxs("div", { className: "dtsw-input-row", children: [_jsx("button", { className: "dtsw-icon", title: "\u8868\u60C5", onClick: () => setEmojiOpen((v) => !v), children: "\uD83D\uDE0A" }), _jsx("button", { className: "dtsw-icon", title: "\u53D1\u9001\u56FE\u7247/\u6587\u4EF6", disabled: uploading || !hasSession, onClick: () => fileRef.current?.click(), children: uploading ? '⏳' : '📎' }), _jsx("textarea", { rows: 1, value: input, placeholder: "\u8BF7\u8F93\u5165\u60A8\u7684\u95EE\u9898\uFF0CEnter \u53D1\u9001", onChange: (e) => onInputChange(e.target.value), onKeyDown: onKeyDown }), _jsx("button", { className: "dtsw-send", onClick: sendText, disabled: !input.trim(), children: "\u53D1\u9001" })] }), _jsxs("div", { className: "dtsw-actions", children: [!human ? (_jsx("button", { className: "dtsw-human", onClick: requestHuman, children: "\u8F6C\u4EBA\u5DE5\u5BA2\u670D" })) : (_jsx("span", { className: "dtsw-tip", children: "\u5BA2\u670D\u5DF2\u63A5\u5165" })), _jsx("span", { className: "dtsw-tip", children: "AI \u52A9\u624B 7\u00D724 \u5728\u7EBF" })] }), _jsx("input", { ref: fileRef, type: "file", hidden: true, accept: boot?.upload.accept ?? 'image/*,.pdf,.zip', onChange: (e) => {
                                            const f = e.target.files?.[0];
                                            e.target.value = '';
                                            if (f)
                                                void onPickFile(f);
                                        } })] }))] })), _jsxs("button", { className: "dtsw-launcher", "aria-label": "\u5728\u7EBF\u5BA2\u670D", onClick: () => {
                            setOpen((v) => !v);
                            setUnread(0);
                        }, children: [open ? '–' : '💬', !open && unread > 0 && _jsx("span", { className: "dtsw-badge", children: unread > 99 ? '99+' : unread })] })] })] }));
}
function MessageBubble({ message, siteBase, showReadStat, onRetry, }) {
    if (message.senderType === 'system') {
        return _jsx("div", { className: "dtsw-sys", children: message.content });
    }
    const card = message.msgType === 'card' && message.meta?.card
        ? message.meta.card
        : null;
    const refs = message.senderType === 'ai' && Array.isArray(message.meta?.refs)
        ? message.meta.refs.filter((r) => r && r.title && r.url)
        : [];
    const label = message.senderType === 'ai' ? 'AI 助手' : message.senderType === 'agent' ? '客服' : '';
    return (_jsx("div", { className: `dtsw-row ${message.senderType === 'visitor' ? 'dtsw-right' : ''}`, children: _jsxs("div", { className: `dtsw-bubble ${message.failed ? 'dtsw-failed' : ''}`, children: [label && _jsx("div", { className: "dtsw-label", children: label }), message.msgType === 'image' && message.assetUrl ? (_jsx("a", { href: message.assetUrl, target: "_blank", rel: "noreferrer", children: _jsx("img", { className: "dtsw-img", src: message.assetUrl, alt: message.content ?? '图片' }) })) : message.msgType === 'video' && message.assetUrl ? (_jsx("video", { className: "dtsw-video", src: message.assetUrl, controls: true })) : message.msgType === 'file' && message.assetUrl ? (_jsxs("a", { className: "dtsw-file", href: message.assetUrl, target: "_blank", rel: "noreferrer", children: ["\uD83D\uDCCE ", message.content || '文件'] })) : card ? (_jsxs("div", { className: "dtsw-card", children: [_jsx("div", { className: "dtsw-card-title", children: card.title }), card.description && _jsx("div", { className: "dtsw-card-desc", children: card.description }), _jsxs("div", { className: "dtsw-card-foot", children: [card.price && _jsx("b", { children: card.price }), card.path && (_jsx("a", { href: joinUrl(siteBase, card.path), target: "_blank", rel: "noreferrer", children: "\u67E5\u770B\u8BE6\u60C5 \u2197" }))] })] })) : (_jsx("div", { className: "dtsw-text", children: message.content })), refs.length > 0 && (_jsx("div", { className: "dtsw-refs", children: refs.map((r, i) => (_jsxs("a", { href: joinUrl(siteBase, r.url), target: "_blank", rel: "noreferrer", children: ["\u53C2\u8003\u8D44\u6599\uFF1A", r.title] }, `${r.url}-${i}`))) })), _jsxs("div", { className: "dtsw-meta", children: [message.pending ? (_jsx("span", { children: "\u53D1\u9001\u4E2D\u2026" })) : (_jsx("span", { title: formatFullTime(message.createdAt), children: formatTime(message.createdAt) })), showReadStat && message.senderType === 'visitor' && !message.pending && (_jsx("span", { children: message.meta?.readByAgentAt ? '已读' : '未读' })), message.failed && (_jsx("button", { onClick: () => onRetry(message), title: "\u91CD\u65B0\u53D1\u9001", children: "\u91CD\u8BD5" }))] })] }) }));
}
export default SupportWidget;
//# sourceMappingURL=SupportWidget.js.map